// extracted by mini-css-extract-plugin
export default {"form-text":"EmailScreen_form-text__3Qs6N","form-body":"EmailScreen_form-body__GM0rD","notification":"EmailScreen_notification__fJaCN"};